/**
 * 获取模板名称，当 name 为空时返回默认值
 *
 * @param name 模板名称
 * @returns 模板名称
 */
export const getTemplateName = (name?: string) => {
  return name || '未命名'
}
